import { RunMode } from '~~/interface/Pos';
import { JobAction, JobItemStatus } from '~~/interface/Job';
import _ from "lodash";
import { defineStore } from "pinia";
import {
  getDatabase, set, update,  ref, onValue, child, onChildAdded,
  getFirestore, doc, setDoc
} from "firebase/database";
import { watch as watchValue } from "vue";


import axios from 'axios';

import dayjs from "dayjs";
import { SETTING_ID } from '~~/interface/Setting';
import { onSnapshot, deleteDoc } from "firebase/firestore";
import { isBusinessSessionStale, type BusinessSessionDoc } from '~~/modules/pos/utils/businessSession';
import { isOpenShopCrossDay } from '~~/modules/pos/utils/businessDate';
import { TableStateEventType } from '~~/interface/TableStateEvent';




export const useJobsStore = defineStore("jobs", {
  state: () => ({
    jobs: [],
    jobsHolder: {} as any,
    tables: {},  // start date, end date, items
    tables_v2: {},  // money summary , rounding

    tablesInfo: {},   // sc/dc2/cc/tax ที่ตั้งเองต่อโต๊ะ — ผล reduce ของ tableStatesEvents (ดู stores/tableStatesEvents.ts)

    uuidItems: {},   // uuid items map
    nonce: _.random(100, 99999999).toString(),
    lastupdate: 0,
    settings: {
      sc: [0, 0],
      dc2: [0, 0],
      tax: [0, 0],
    },
    openShop: null,
    // ทะเบียนรอบการขายบน Firestore (ดู modules/pos/utils/businessSession.ts) null = ไม่มี doc
    businessSession: null as BusinessSessionDoc | null,
    delayComputeFn: () => { },
    paidAmount: 0,
    // เวลาปัจจุบัน (ms) ให้ getter ที่อิงเวลาคำนวณใหม่ได้ ถูก tick ทุกนาทีจาก layouts/default.vue
    nowTs: Date.now(),
  }),
  getters: {
    itemsCombined(state) {
      return function (table: any, { bill, sort, limit, offset }) {
        
        let items: any = [];
        let itemsToBeAdded = [];

        if (table && state.tables[table] && state.tables[table].items) {
          itemsToBeAdded = state.tables[table].items;
        }


        if (bill !== 'all') {
          itemsToBeAdded= itemsToBeAdded.filter((item) => item.bill == bill)
        
        }

        itemsToBeAdded.forEach((item) => {


          let itemCloned = _.cloneDeep(item)
          itemCloned.key = utilsItemGenKey(itemCloned)
          let index = items.findIndex((i: any) => i.key === itemCloned.key)
          if (index > -1) {
            items[index].qty += item.qty
            items[index].subTotal += item.subTotal
            items[index].extendedPrice += item.extendedPrice
            items[index].extendedPriceWithDiscount += item.extendedPriceWithDiscount

            items[index].dc1[2] = items[index].dc1[2] + item.dc1[2]
            items[index].sc[2] = items[index].sc[2] + item.sc[2]
            items[index].dc2[2] = items[index].dc2[2] + item.dc2[2]
            items[index].cc[2] = items[index].cc[2] + item.cc[2]
            items[index].tax[2] = items[index].tax[2] + item.tax[2]

            items[index].amount += item.amount



          } else {
            items.push(itemCloned)
          }

        })

        // if (bill != 'all') {
        //   items = items.filter((item) => item.bill == bill)
        // }

        // ชิ้นที่ถูกแยกออกมาเป็นคนละแถวกับต้นทาง (ถูกแล้ว) แต่ job ของมันไปต่อท้าย
        // แถวใหม่เลยไปโผล่คนละมุมกับตัวเดิม ทั้งที่เป็นสินค้าตัวเดียวกัน
        // เรียงตามลำดับที่ "กลุ่มสินค้า" นั้นโผล่ครั้งแรก เพื่อดึงมาอยู่ติดกัน
        //
        // sortBy ของ lodash เป็น stable ของที่ไม่เคยถูกแยกจึงเรียงตามเดิมทุกแถว
        // และการเรียงใหม่ไม่กระทบยอดเงิน เพราะทุกที่ที่ใช้ต่อเป็นการบวกรวม
        // ห้ามแปะ field ช่วยจำลงบน item เด็ดขาด ผลลัพธ์ของ getter นี้ถูกส่งเข้า
        // .withItems() ของ job จ่ายเงิน/พิมพ์ ของแถมจะไหลลง payload จริงไปด้วย
        // ห้ามแปะ field ช่วยจำลงบน item เด็ดขาด ผลลัพธ์ของ getter นี้ถูกส่งเข้า
        // .withItems() ของ job จ่ายเงิน/พิมพ์ ของแถมจะไหลลง payload จริงไปด้วย
        // จึงห่อไว้ชั้นนอกแล้วค่อยแกะกลับ (sortBy ส่ง index ให้ iteratee ไม่ได้)
        const groupOrder: any = {}
        const ranked = items.map((item: any) => {
          const groupKey = `${utilsItemGroupKey(item)}#bill${item.bill ?? 1}`
          if (groupOrder[groupKey] === undefined) {
            groupOrder[groupKey] = _.keys(groupOrder).length
          }
          return { item, rank: groupOrder[groupKey] }
        })

        return _.sortBy(ranked, "rank").map((entry: any) => entry.item);
      }
    },
    getStautsByUuid(state) {
      return function (uuid) {
        return state.uuidItems[uuid].status;
      }
    },
    getItemByUuid(state) {
      return function (uuid) {
        return state.uuidItems[uuid];
      }
    },
    getUuidItemsByTable(state) {
      return function (table, status) {
        let uuidItems = _.filter(state.uuidItems, (item) => item.table == table && item.status == status)
        return uuidItems;
      }
    },
    getBusinessDate(state) {
      let openObj = _.find(state.jobs, (job) => job.action == JobAction.OPEN)
      if (openObj) {
        return {
          businessDate: openObj.businessDate,
          shift: openObj.shift,
          timestamp: openObj.timestamp,
          nonce: openObj.nonce
        }
      } else {
        return null;
      }

    },
    getOpenJob(state) {
      let openObj = _.find(state.jobs, (job) => job.action == JobAction.OPEN)
      if (openObj) {
        return {
          ...openObj,
        }
      } else {
        return null;
      }

    },
    getCloseJob(state) {
      let closeObj = _.find(state.jobs, (job) => job.action == JobAction.CLOSE)
      if (closeObj) {
        return {
          ...closeObj,
        }
      } else {
        return null;
      }

    },

    computeMoneyOneTable(state) {
      return function (table, roundingType:string) {
        return utilsItemComputeOneTable({...state.tables[table], roundingType})

      }
    },

    computeMoneyOneTableWithItemsFiltered(state) {
      return function (tableData, roundingType:string) {
        return utilsItemComputeOneTable({...tableData, roundingType})

      }
    },

    // เครื่องนี้ถือ OPEN ของรอบที่ปิดไปแล้ว ห้ามออกใบเสร็จจนกว่าจะโหลดใหม่
    isSessionStale(state) {
      return isBusinessSessionStale(state.openShop, state.businessSession)
    },

    // เปิดร้านค้างข้ามวันขาย (ลืมปิดร้าน) ใช้ทำ navbar สีแดงและ modal เตือนหน้า /pos
    // กติกาอยู่ที่ modules/pos/utils/businessDate.ts
    isOpenShopCrossDate(state) {
      return isOpenShopCrossDay(state.openShop, state.nowTs)
    }
  },
  actions: {
    tickNow() {
      this.nowTs = useServerTime().getCorrectedDayjsInstance().valueOf()
    },
    init() {
      setTimeout(() => {
        this.setupSettings()
      }, 400);
      setTimeout(() => {
        this.setupSettings()
      }, 4000);
      // ยังไม่เลือกโหมด = ขายไม่ได้ (/pos กับ /dashboard พาไปหน้าเลือกโหมดเสมอ) ไม่ต้องฟัง jobchain
      // tab ที่เปิดทิ้งไว้ (เช่นบนมือถือ) จะได้ไม่สะสม job / ไม่ดึงทั้ง node ทุกครั้งที่เบราว์เซอร์ปลุก
      // เลือกโหมดแล้วหน้าโหลดใหม่ทั้งหน้า (requestRunMode → location.replace) init รอบใหม่ฟังเอง
      if (useRunningMode().getMode() !== RunMode.UNASSIGNED) {
        this.watch()
        this.watchBusinessSession()
        this.watchSessionEnded()
        this.watchHandshake()
      }
      this.delayCompute()
      setTimeout(() => {
        this.setupSettings()
      }, 8000);
    },
    setupSettings() {
    
      let settingStore = useSettingsStore()
      let sc = settingStore.getValueBysettingId(SETTING_ID.SERVICE_CHARGE, 0)
      let dc2 = settingStore.getValueBysettingId(SETTING_ID.DISCOUNT_BILL, 0)
      let taxMode = settingStore.getValueBysettingId(SETTING_ID.TAX_MODE, 0)
      let taxValue = settingStore.getValueBysettingId(SETTING_ID.TAX_VALUE, 0)

      //Overide Tax When Not Input 
      if(isNaN(parseInt(taxValue))){
        taxValue = 0
      }

      this.settings = {
        sc: [0, parseInt(sc)],
        dc2: [0, parseInt(dc2)],
        tax: [parseInt(taxMode), parseInt(taxValue)]
      }

        // this.delayCompute()
        this.delayComputeFn()
    },
    delayCompute() {
      const computeFn = _.debounce(this.compuet, 200)
      this.delayComputeFn = computeFn
      let previousJobsRef = {}
      this.$subscribe((mutation, state) => {

        //if previousJobsRef changed 
        if (previousJobsRef != state.jobsHolder) {
          previousJobsRef = state.jobsHolder

          computeFn()
        }




      })
    },
    //step 1
    add(job, syncToCloud = false) {

      // job ที่เครื่องนี้สร้างเอง (syncToCloud) จากโหมด Audit = ดูอย่างเดียว ห้ามเกิด
      // (job ที่ sync เข้ามาจากเครื่องอื่นไม่ส่ง syncToCloud ผ่านได้ตามปกติ)
      if (syncToCloud && blockIfAudit(`job ${job?.action ?? ""}`)) return;

      // "last data sync" = timestamp ของ job ล่าสุดที่เครื่องนี้มีอยู่
      // ใช้เวลาของตัว job ไม่ใช่ Date.now() เพราะ job อาจถูกสร้างจากแคชเชียร์ 2
      // หรือเครื่องอื่นแล้ว sync เข้ามา — ต้องบอกได้ว่า "ข้อมูลที่เห็นอยู่ล่าสุดถึงเมื่อไหร่"
      //
      // ของเดิมมีแต่ main cashier ที่ได้ค่านี้ (เขียนจาก mobile.items.plugin)
      // เครื่องอื่นจึงค้างที่ 0 = โชว์ 01/Jan 07:00:00
      //
      // เทียบเป็น epoch ก่อนเสมอ เพราะ job.timestamp มีทั้งแบบ ISO string และตัวเลข
      // และ onChildAdded อาจส่ง job เก่ามาทีหลัง — เก็บเฉพาะค่าที่ใหม่กว่าเดิม
      if (job?.timestamp) {
        const jobTime = dayjs(job.timestamp).valueOf();
        if (!isNaN(jobTime) && jobTime > dayjs(this.lastupdate).valueOf()) {
          this.lastupdate = job.timestamp;
        }
      }

      // key ต้องเป็นตัวเดียวกับ key บน RTDB = {timestamp}_{โต๊ะ}
      //
      // ของเดิมใช้ timestamp ล้วน ทุกเครื่องดึงนาฬิกาตาม server time จึงได้ millisecond
      // ตรงกันได้จริง: job ของอีกเครื่อง (คนละโต๊ะ) ที่มาถึงก่อนทำให้ job ที่มาทีหลังถูกทิ้งเงียบ ๆ
      // ทั้งที่บน RTDB มีครบ แล้วตอนปิดร้าน syncJobsToCloud() บันทึก jobsHolder นี้ลง Firestore
      // job นั้นจึงหายถาวร (เคสจริง charter 2026-10-01: PAY โต๊ะ X17 ชน ADD โต๊ะ B6 ที่ .122Z
      // บิลจ่ายแล้วแต่ของค้างบนโต๊ะ ถูก void ตอนปิดร้าน)
      const key = utilsJobKey(job);
      if (this.jobsHolder[key] == undefined) {
        this.jobsHolder = {
          ...this.jobsHolder,
          [key]: job
        }

        // ปิดร้านลบ tableStatesEvents ทั้ง node ซึ่งไม่ทำให้ onChildAdded ยิง
        // ทุกเครื่องได้ CLOSE job ทาง jobchain อยู่แล้ว จึงใช้เป็นสัญญาณล้างสถานะโต๊ะในเครื่อง
        // รอบที่ถูกปิด = OPEN ตัวล่าสุดก่อน CLOSE นี้ (เผื่อ jobchain ไม่ถูกล้าง แล้ว CLOSE ของรอบก่อนไหลมาตอนบูต)
        if (job?.action === JobAction.CLOSE) {
          const closeAt = dayjs(job.timestamp).valueOf()
          const closedOpen: any = _.maxBy(
            _.filter(_.values(this.jobsHolder), (j: any) =>
              j?.action === JobAction.OPEN && dayjs(j.timestamp).valueOf() <= closeAt),
            (j: any) => dayjs(j.timestamp).valueOf()
          )
          useTableStatesEventsStore().onCloseShop(job, closedOpen?.jobId ?? null)
        }
      }

    },

    rePrint(job) {

      // if (this.jobsHolder[job.timestamp] == undefined) {
      //   this.jobsHolder = {
      //     ...this.jobsHolder,
      //     [job.jobId]: job
      //   }

      //   // this.jobsHolder[job.timestamp] = job

      // }

    },

    addFromLocalhost(job) {

      const key = utilsJobKey(job);
      if (this.jobsHolder[key] == undefined) {
        this.jobsHolder = {
          ...this.jobsHolder,
          [key]: job
        }
      }
    },

    compuet() {
      // const _jobs = Object.values(this.jobsHolder)
      const _jobs = _.values(this.jobsHolder)
      this.jobs = _.sortBy(_jobs, ['timestamp'])
      if (this.openShop == null) {
        this.openShop = this.jobs.find((job) => job.action == JobAction.OPEN)
      }

      const isJobchainV2 = useShopStore().getIsJobchainV2
      let jobchain =null;
      if(true || isJobchainV2){ 
        jobchain  = new JobChainV2(this.jobs);
      }else { 
        jobchain = new JobChain(this.jobs);
      }


      this.tables = jobchain.getTables();

      const posStore = usePosStore();
     
      const tableState = posStore.tableState   


      const settingsStore = useSettingsStore();
      const channelSettings = settingsStore.getValueBysettingId("channels", []);

      // combine tables info service charge, discount bill, tax
      new TablesBuilder().computeTableItems(this.tables, this.tablesInfo, this.settings, tableState, channelSettings);
      this.uuidItems = jobchain.getItems();


      
            
      const roundingType =  settingsStore.getRoundingType
   


      let tables_v2 = computeTablesMap(this.tables, { roundingType})
      this.tables_v2 = tables_v2

      let amount = computePaidAmount(this.jobs);
      this.paidAmount = amount;
    },


    // Realtime DB
    watch() {


      let fb_realtimeDatabase = useFirebase()
      const jobChainRef = fb_realtimeDatabase.jobchainRef()

      onChildAdded(jobChainRef, (snapshot) => {
        const jobFromCloud = snapshot.val();


        // if nonce same, then not push to store
        if (jobFromCloud.nonce == this.nonce) {
          return
        }

        this.add(jobFromCloud, false)
      }, (error) => {
        // error callback ของ listener — ตาข่ายกันเหนียว
        // ปกติไม่ยิงจาก permission เพราะ .read ของ jobchain เปิดสาธารณะไว้
        // (แอปเจ้าของร้านต้องอ่าน) เหลือไว้เผื่อ rules เปลี่ยนกลับไปล็อค .read
        useRtdbGuardStore().reportJobchainFailure('watch:onChildAdded', error)
      });


    },

    // มีรอบการขายใหม่กว่าที่เครื่องนี้ถือ (ร้านปิดแล้วเปิดรอบใหม่) — โหลดใหม่เมื่อว่าง
    // ไม่ใช้ child_removed ของ jobchain เป็นสัญญาณ เพราะบางทีลบ job ใน RTDB ด้วยมือตอนแก้บั๊ก
    // key ผูกกับ OPEN ที่ถืออยู่ โหลดแล้วยังค้างรอบเดิม (jobchain ล้างไม่หมด) จะไม่โหลดวน
    // ด่านก่อนชำระเงิน (useSessionStale) ยังกันอยู่เหมือนเดิมระหว่างรอเครื่องว่าง
    watchSessionEnded() {
      watchValue(() => this.isSessionStale, (stale) => {
        if (!stale) return
        useAppControlStore().requestReload({
          source: 'session_stale',
          key: `session_stale:${this.openShop?.jobId ?? 'none'}`,
          reason: 'มีรอบการขายใหม่กว่า (businessSession)',
          jitter: true,
        })
      }, { immediate: true })
    },

    // Firestore listener ต่อใหม่และส่ง doc ล่าสุดมาให้เองหลังเครื่องตื่นจาก sleep
    // จึงไม่ต้องมีตัวจับ sleep / visibilitychange แยก
    watchBusinessSession() {
      onSnapshot(useFirebaseFirestore().businessSessionDocRef(), (snapshot) => {
        this.businessSession = snapshot.exists() ? (snapshot.data() as BusinessSessionDoc) : null
      }, (error) => {
        // อ่านไม่ได้ = ไม่รู้ว่าค้างรอบไหม ถือว่าขายได้ตามเดิม (ไม่มี doc = ขายได้)
        console.warn("[businessSession] อ่าน doc ไม่ได้ ข้ามไปก่อน", error)
      })
    },

    // ปิดร้าน (Main Cashier) = ลบทะเบียนรอบการขาย ต้องลองซ้ำเพราะถ้าลบไม่ได้
    // รอบถัดไปจะ append ต่อจาก doc เก่า แล้วจับเครื่องที่ค้างรอบนี้ไม่ได้ (ร้านยังขายได้ปกติ)
    async clearBusinessSession() {
      const docRef = useFirebaseFirestore().businessSessionDocRef()
      let lastError = null
      for (let attempt = 1; attempt <= 3; attempt++) {
        try {
          await deleteDoc(docRef)
          return
        } catch (error) {
          lastError = error
          await new Promise((resolve) => setTimeout(resolve, 1000 * attempt))
        }
      }
      throw lastError
    },

    watchLocal() {
      return

      let timer = setTimeout(fetchJobsLocal, 1000);
      async function fetchJobsLocal() {

        try {
          const res = await axios.get('http://localhost:3000/jobs')
          const jobs = res.data.jobs;
          jobs.forEach((job) => {
            this.addFromLocalhost(job);
          })

        } catch (error) {
          console.log(error)
        }




        timer = setTimeout(fetchJobsLocal, 1000);
      }
    },


    // handshake
    async watchHandshake() {


      let mode = useRunningMode().getMode()

      if (mode === RunMode.MAIN_CASHIER) {

        let handshakeRef = useFirebase().handshakeRef()
        await set(handshakeRef, null)
        onChildAdded(handshakeRef, (snapshot) => {
          const request = snapshot.val();

          if (request == 1) {
            let newRef = child(handshakeRef, snapshot.key)
            set(newRef, 2)
            setTimeout(() => {
              set(newRef, null)
            }, 2000);
          }

        });

        let jobRequestRef = useFirebase().jobRequestRef()
        onChildAdded(jobRequestRef, (snapshot) => {

          // terminal / mobile-order-flutter ฝากสถานะโต๊ะ (channel / แขก ที่เลือกตอนเปิดโต๊ะใหม่) มากับ job
          // แยกออกก่อนเขียน jobchain แล้วเขียนเป็น event สถานะโต๊ะแทน (ดู tableStatesEvents.applyPendingTableState)
          const { pendingTableState, ...job } = snapshot.val() || {};
          this.add(job, true)
          useTableStatesEventsStore().applyPendingTableState(job.table, pendingTableState, job.jobId, job.orderChannel)
          let newRef = child(jobRequestRef, snapshot.key)
          set(newRef, null)

        });
      }

    },


    // step2 - options (sc / dc2 / cc / tax ของโต๊ะ) — เขียนเป็น event แล้ว reduce กลับมาเป็น this.tablesInfo
    setOptions(table, node, payload) {
      useTableStatesEventsStore().appendEvent(table, TableStateEventType.SET_OPTION, {
        payload: { key: node, value: payload },
      })
    },
    // ล้างค่าเฉพาะช่องเดียวของโต๊ะ ให้กลับไปใช้ค่าเริ่มต้นของร้าน
    resetOptions(table, node) {
      useTableStatesEventsStore().appendEvent(table, TableStateEventType.RESET_OPTION, {
        payload: { key: node },
      })
    },

    //step3 - update status


    async syncJobsToCloud() {

      // ไม่มี OPEN job = อ่าน businessDate/shift ไม่ได้ ของเดิมจะเป็น TypeError เงียบ ๆ
      // แล้วแยกไม่ออกจากสาเหตุอื่น ทำให้ debug ยาก
      if (this.openShop == null) {
        throw new Error("syncJobsToCloud: ไม่พบ OPEN job จึงไม่รู้ businessDate/shift")
      }

      let _jobs = (this.jobsHolder)


      let data = {
        jobs: _jobs,
        storeId: useStoreId(),
        businessDate: this.openShop.businessDate,
        shift: this.openShop.shift,
        nonce: this.nonce,
        startedAt: this.openShop.timestamp,
        closedAt: dayjs().toISOString()
      }

      let { addDayJobs } = useFirebaseFirestore()

      // ถ้าเขียนไม่สำเร็จต้องให้ error ลอยขึ้นไปถึงเช็คลิสต์ปิดร้าน
      // ห้ามกลืน ไม่งั้นจะขึ้นเขียวว่าสำเร็จแล้ว jobchain ถูกลบทิ้งทั้งที่ข้อมูลยังไม่ขึ้น cloud
      return addDayJobs(`${data.businessDate}:${data.shift}`, data)


    },


    // close pos
    async clearJobs(reload = false) {

      this.jobs = [];
      let fb_realtimeDatabase = useFirebase()
      const jobChainRef = fb_realtimeDatabase.jobchainRef()

      try {
        await set(jobChainRef, null)
      } catch (error) {
        // ปิดร้านไม่สำเร็จ ถ้าปล่อยผ่านแล้ว reload ไป job เก่าจะยังค้างบน cloud
        // แล้วไหลกลับเข้ามาใหม่ ต้องกั้นไว้ก่อน
        useRtdbGuardStore().reportJobchainFailure('clearJobs', error)
        throw error
      }

      if (reload) {
        window.location.href = "/";
      }
    }

  },
});







//---------------------- jobchain.js ----------------------//




function computeTablesMap(tablesMap, {  roundingType }) {

  let _res = {}
  _.forEach(tablesMap, (table, index) => {

    const { subTotal, dc1, sc, dc2, tax, cc, rounding, grandTotal } = utilsItemComputeSummary(table.items, roundingType)


    _res[index] = {
      subTotal: subTotal,
      dc1: dc1,
      sc: sc,
      dc2: dc2,
      cc:cc,
      tax: tax,
      rounding: rounding,
      grandTotal: grandTotal + rounding,
      itemsLength: table.items.length,
    }
  })




  return _res

}


function computePaidAmount(jobs)  {
	const payJobs = _.filter(jobs, (job) => job.action === "PAY");
	const sum = _.sumBy(_.flatMapDeep(payJobs, 'payment'), 'amount');	
	return sum || 0;
    }


